import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { constants } from '../../../common/constants/constants';
import useBodyClass from '../../../common/hooks/useBodyClassName';
import envelope from '../../../images/newDesign/envelope.svg';
import arrow from '../../../images/newDesign/arrow.svg';
import { StyledThankYouWrapper } from './ThankYouPage.styled';

const ThankYouPage = ({ match }) => {
    const { t } = useTranslation();
    const history = useHistory();
    const ltr = useSelector(state => state.common.ltrEnabled);

    const { buildingID } = match.params;

    useBodyClass('payment-flow');

    const onBackBtnClick = () => history.push({ pathname: `/${constants.pages.buildingsUrl}/${buildingID}`});

    return (
        <StyledThankYouWrapper ltr={ltr}>
            <div className='back-btn' onClick={onBackBtnClick}><img src={arrow} />{t('auto_charge.back')}</div>

            <div className='thanks'>{t('maintenance.thanks')}</div>
            <div className='form-sent'>{t('maintenance.form_submitted')}</div>
            <img className='envelope' src={envelope} />
        </StyledThankYouWrapper>
    )
}

export default ThankYouPage;